module.exports = __webpack_public_path__ + "static/img/v41DetailImg.7b22875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v41DetailImg.png
// module id = ZP4J
// module chunks = 1